const CommentActionTypes = {
  FETCH_COMMENTS_START: "FETCH_COMMENTS_START",
  FETCH_COMMENTS_SUCCESS: "FETCH_COMMENTS_SUCCESS",
  FETCH_COMMENTS_FAILURE: "FETCH_COMMENTS_FAILURE",
  CREATE_COMMENT_START: "CREATE_COMMENT_START",
  CREATE_COMMENT_SUCCESS: "CRREATE_COMMENT_SUCCESS",
  CREATE_COMMENT_FAILURE: "CREATE_COMMENT_FAILURE",
};

export default CommentActionTypes;
